import { render } from "./CardPageVisits.vue?vue&type=template&id=54553287"
const script = {}
script.render = render

export default script